import { Link } from "react-router";
import { RouteEnum } from "../../../../common/enums/RouteEnum";
import { InputField } from "@hatch-digital-nl/abs-storybook/legacy";
import { setCurrentPage, setSearchTerm } from "../../CertificateSlice";
import { useAppDispatch } from "../../../../app/hooks";
import searchImage from "../../../../common/images/search.svg";
import { useGetEmployeeMeQuery } from "../../../../common/api/employee";
import { debounce } from "../../../../common/utils/debounce";
import { JSX } from "react";

export const EmployeeCertificatesHeader = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { data: employeeMeData } = useGetEmployeeMeQuery({});

    return (
        <div className="p-certificates__header">
            <div className="c-breadcrumbs">
                <span>
                    Dashboards / <Link to={RouteEnum.DASHBOARD}>LMS</Link> /
                    Vestigingen / {employeeMeData?.establishment?.name} /
                    Overzicht certificaten
                </span>
            </div>
            <div className="c-header-search">
                <div className="c-header-search__title">
                    <h2>Certificaten</h2>
                </div>
                <div className="c-header-search__search">
                    <InputField
                        placeHolder={"Zoeken..."}
                        iconRight={searchImage}
                        onChange={debounce((value: string) => {
                            dispatch(setSearchTerm(value));
                            dispatch(setCurrentPage(1));
                        })}
                    />
                </div>
            </div>
        </div>
    );
};
